import { httpCreate } from './http';

const http = httpCreate('/srv/sysMsg');

export const sysMsg = {
	//获取公告列表
	getNotice(params) {
		return http.get('/list', { params });
	},
	//新增公告
	addNotice(data) {
		return http.post('/create', data);
	},
	//撤回编辑公告
	recallNotice(id) {
		return http.get(`/withdraw/${id}`);
	},
	//修改公告
	changeNotice(data) {
		return http.post('/update', data);
	},
	//获取公告详情
	getNoticeDetails(id) {
		return http.get(`/detail/${id}`);
	},
	//删除公告
	deleteNotice(id) {
		return http.get(`/delete/${id}`);
	},
	//获取用户公告
	//page, pageNum, pageSize, photoLive
	getList(params) {
		return http.get('/user/list', { params });
	},
	//删除用户公告
	getDelete(params) {
		return http.get('/user/delete', { params });
	},
	//获取用户详细公告
	getDetail(id) {
		return http.get(`/user/getDetail/${id}`);
	},
	//用户端标记为已读
	tagRead(params) {
		return http.get('/user/tagRead', { params });
	},
	//用户端全部标记已读
	tagReadAll(photoLive = 0) {
		return http.get(`/user/tagReadAll?photoLive=${photoLive}`);
	},
	//用户端获取未读消息数量
	notRead(photoLive = 0) {
		return http.get(`/user/notRead?photoLive=${photoLive}`);
	},
	// 获取用户当前最新的未读消息
	getMsgNewone() {
		return http.get('/user/newOne?photoLive=0');
	},
};
